<template>
  <div class="create-qrcode">
    <div class="bottom-title">
      <div class="bottom-text">设计二维码样式</div>
      <div class="submit-btn" v-if="!submitStatus">
        <el-button size="small" @click="clearQrStyle">清 除 样 式</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="submitForm">提 交 审 核</el-button>
      </div>
    </div>
    <div>
      <div class="create-box">
        <div class="create-lr-box">
          <div class="code-qr-box">
            <vue-qr text="https://wx.shuibengcloud.com/"
                    :callback="qrCallback"
                    :size="qrOptions.size"
                    :margin="qrOptions.margin"
                    :backgroundColor="qrOptions.backgroundColor"
                    :colorDark="qrOptions.colorDark"
                    :logoSrc="qrOptions.logoSrc"
                    :colorLight="qrOptions.colorLight"
                    :logoScale="qrOptions.logoScale"
                    :logoMargin="qrOptions.logoMargin"
                    :logoCornerRadius="qrOptions.logoCornerRadius"
                    :bgSrc="qrOptions.bgSrc"
                    :correctLevel="qrOptions.correctLevel">
            </vue-qr>
          </div>
          <div class="info-box">
            <div>
              <div style="text-align:center;">
                <img src="../../assets/codeTraceability.png" alt="" style="width:450px">
              </div>
            </div>
            <!--            <div class="info-title">-->
            <!--              <i class="el-icon-caret-right info-icon"></i>颜色设置-->
            <!--            </div>-->
            <!--            <div class="info-item-box">-->
            <!--              <div class="info-color-item">-->
            <!--                <div class="info-color-label">背景色</div>-->
            <!--                <el-color-picker v-model="qrOptions.colorLight" show-alpha-->
            <!--                                 @active-change="onChangeColor($event,'colorLight')"-->
            <!--                                 @change="onChangeColor($event,'colorLight')"></el-color-picker>-->
            <!--              </div>-->
            <!--              <div class="info-color-item">-->
            <!--                <div class="info-color-label">前景色</div>-->
            <!--                <el-color-picker v-model="qrOptions.colorDark" show-alpha-->
            <!--                                 @active-change="onChangeColor($event,'colorDark')"-->
            <!--                                 @change="onChangeColor($event,'colorDark')"></el-color-picker>-->
            <!--              </div>-->
            <!--              <div class="info-color-item">-->
            <!--                <div class="info-color-label">码底色</div>-->
            <!--                <el-color-picker v-model="qrOptions.backgroundColor" show-alpha-->
            <!--                                 @active-change="onChangeColor($event,'backgroundColor')"-->
            <!--                                 @change="onChangeColor($event,'backgroundColor')"></el-color-picker>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="create-lr-box">
          <div class="info-box">
            <div class="info-title">
              <i class="el-icon-caret-right info-icon"></i>基础设置
            </div>
            <div class="info-logo-item">
              <div class="item-label">大小</div>
              <el-slider style="width: 100%;" :min="64" :max="460" v-model="qrOptions.size" show-input
                         :step="1" @change="onChangeSlider($event,'size')"/>
            </div>
            <div class="info-logo-item">
              <div class="item-label">外边距</div>
              <el-slider style="width: 100%;" :min="0" :max="50" v-model="qrOptions.margin" show-input
                         :step="1" @change="onChangeSlider($event,'margin')"/>
            </div>
            <div class="info-logo-item">
              <div class="item-label">容错率</div>
              <el-slider style="width: 100%;" :min="0" :max="3" v-model="qrOptions.correctLevel" show-input
                         :marks="{1:'10%',2:'20%',3:'30%'}" :step="1"
                         @change="onChangeSlider($event,'correctLevel')"/>
            </div>
          </div>
          <!--          <div class="info-box">-->
          <!--            <div class="info-title">-->
          <!--              <i class="el-icon-caret-right info-icon"></i>logo设置-->
          <!--            </div>-->
          <!--            <div class="info-item-box">-->
          <!--              <div class="info-logo-item" style="margin-bottom: 0;">-->
          <!--                <el-upload-->
          <!--                    v-model="qrOptions.logoSrc"-->
          <!--                    :file-list="fileLogoList"-->
          <!--                    action="/service-center/upload/file/single"-->
          <!--                    :headers="headers"-->
          <!--                    list-type="picture-card"-->
          <!--                    :before-upload="handleBeforeUpload"-->
          <!--                    :on-preview="handleCardPreview"-->
          <!--                    :on-remove="handleLogoRemove"-->
          <!--                    :on-change="handleLogoChange"-->
          <!--                    :on-success="handleLogoSuccess">-->
          <!--                  <i class="el-icon-plus"></i>-->
          <!--                  <div class="el-upload__tip" slot="tip">* 请上传格式为png或jpg,且不超过2M的图片</div>-->
          <!--                </el-upload>-->
          <!--              </div>-->
          <!--              <div v-show="qrOptions.logoSrc">-->
          <!--                <div class="info-logo-item" style="margin: 30px 0;">-->
          <!--                  <div class="item-label">边距</div>-->
          <!--                  <el-slider style="width: 100%;" :min="0" :max="3" v-model="qrOptions.logoMargin" show-input-->
          <!--                             :step="1" @change="onChangeSlider($event,'logoMargin')"/>-->
          <!--                </div>-->
          <!--                <div class="info-logo-item" style="margin-bottom: 0;">-->
          <!--                  <div class="item-label">圆角</div>-->
          <!--                  <el-slider style="width: 100%;" :min="0" :max="16" v-model="qrOptions.logoCornerRadius" show-input-->
          <!--                             :step="1" @change="onChangeSlider($event,'logoCornerRadius')"/>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="info-box">-->
          <!--            <div class="info-title">-->
          <!--              <i class="el-icon-caret-right info-icon"></i>背景图设置-->
          <!--            </div>-->
          <!--            <div class="info-item-box">-->
          <!--              <div class="info-logo-item" style="margin-bottom: 0;">-->
          <!--                <el-upload-->
          <!--                    v-model="qrOptions.bgSrc"-->
          <!--                    :file-list="fileBgList"-->
          <!--                    action="/service-center/upload/file/single"-->
          <!--                    :headers="headers"-->
          <!--                    list-type="picture-card"-->
          <!--                    :before-upload="handleBeforeUpload"-->
          <!--                    :on-preview="handleCardPreview"-->
          <!--                    :on-remove="handleBgRemove"-->
          <!--                    :on-change="handleBgChange"-->
          <!--                    :on-success="handleBgSuccess">-->
          <!--                  <i class="el-icon-plus"></i>-->
          <!--                  <div class="el-upload__tip" slot="tip">* 请上传格式为png或jpg,且不超过2M的图片</div>-->
          <!--                </el-upload>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <el-dialog append-to-body :visible.sync="dialogImgVisible">
      <img width="100%" :src="dialogImgUrl" alt="">
    </el-dialog>
    <!--批量制作二维码-->
    <vue-qr v-for="(item, index) in waterPumpList" :key="index"
            :text="'https://wx.shuibengcloud.com/#/pages/codeTraceability/scanQrCode?code='+item.waterPumpCode"
            :callback="(e)=>qrBatchCallback(e,item)"
            :size="qrOptions.size"
            :margin="qrOptions.margin"
            :backgroundColor="qrOptions.backgroundColor"
            :colorDark="qrOptions.colorDark"
            :logoSrc="qrOptions.logoSrc"
            :colorLight="qrOptions.colorLight"
            :logoScale="qrOptions.logoScale"
            :logoMargin="qrOptions.logoMargin"
            :logoCornerRadius="qrOptions.logoCornerRadius"
            :bgSrc="qrOptions.bgSrc"
            :correctLevel="qrOptions.correctLevel"
            :bindElement="false">
    </vue-qr>
  </div>
</template>

<script>
import VueQr from "../../utils/vue-qr/vue-qr.js";
import {getEnterprise, sendCodeTraceabilitySaveQrCode, sendCodeTraceabilityUpdateQrBatch} from "../../utils/interface";

export default {
  components: {
    VueQr,
  },
  data() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      dataRules: {
        enterpriseName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
        ],
      },
      productInfo: {},
      queryParams: {
        current: 1,
        pageSize: 5,
        total: 0,
      },
      dialogImgUrl: '',
      dialogImgVisible: false,
      fileLogoList: [],
      fileBgList: [],
      submitLoading: false,
      qrOptions: {
        base64Url: '',
        colorLight: '#fff',
        colorDark: '#000000',
        backgroundColor: '#fff',
        logoSrc: '',
        logoScale: 0.2,//超过0.2基本上无法识别
        logoMargin: 2,
        logoCornerRadius: 0,
        bgSrc: '',
        size: 200,
        margin: 20,
        correctLevel: 3,
      },
      isFinished: 0,
      productData: {},
      waterPumpList: [],
      submitStatus: false,
    };
  },
  watch: {
    isFinished: {
      handler(val) {
        let that = this
        if (val === 2) {
          this.submitLoading = false
          this.submitStatus = true
          this.$alert('提交成功，请耐心等待审核。', '提示', {
            confirmButtonText: '确定',
          }).then(() => {
            that.$emit('onChangeStep', 1)
            that.$emit('onChangeType', 1)
          })
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {

  },
  methods: {
    initData(product, list) {
      this.productData = product
      this.waterPumpList = list
      this.getCompanyEnterprise()
    },
    submitForm() {
      let data = {
        enterpriseUuid: this.productData.enterpriseUuid,
        qrCode: this.qrOptions,
        qrContent: this.qrOptions.base64Url,
      }
      this.submitLoading = true
      sendCodeTraceabilitySaveQrCode(data).then((res) => {
        ++this.isFinished
      }).catch(err => {
        this.submitLoading = false
        this.$message.warning('提交失败！')
      })

      this.submitLoading = true
      let newList = []
      this.waterPumpList.map(item => {
        let obj = {uuid: item.uuid, qrContent: item.qrContent}
        newList.push(obj)
      })
      sendCodeTraceabilityUpdateQrBatch(newList).then((res) => {
        ++this.isFinished
      }).catch(err => {
        this.submitLoading = false
        this.$message.warning('提交失败！')
      })
    },
    getCompanyEnterprise() {
      getEnterprise().then((res) => {
        if (res.data.qrCode) {
          this.qrOptions = res.data.qrCode
          if (res.data.qrCode.logoSrc) {
            this.fileLogoList = [{url: res.data.qrCode.logoSrc}]
          }
          if (res.data.qrCode.bgSrc) {
            this.fileBgList = [{url: res.data.qrCode.bgSrc}]
          }
        }
      })
    },
    qrCallback(url) {
      let that = this
      this.$nextTick(() => {
        that.qrOptions.base64Url = url
      })
    },
    qrBatchCallback(url, row) {
      row.qrContent = url
    },
    onChangeColor(e, key) {
      let that = this
      this.$nextTick(() => {
        that.qrOptions[key] = e
      })
    },
    onChangeSlider(e, key) {
      let that = this
      this.$nextTick(() => {
        that.qrOptions[key] = e
      })
    },
    handleLogoSuccess(file, fileList) {
      this.qrOptions.logoSrc = file.url
      this.fileLogoList = fileList
    },
    handleLogoChange(file, fileList) {
      this.fileLogoList = fileList.slice(-1)
    },
    handleLogoRemove(file, fileList) {
      this.qrOptions.logoSrc = ''
      this.fileLogoList = fileList
    },
    handleBgSuccess(file, fileList) {
      this.qrOptions.bgSrc = file.url
      this.fileBgList = fileList
    },
    handleBgChange(file, fileList) {
      this.fileBgList = fileList.slice(-1)
    },
    handleBgRemove(file, fileList) {
      this.qrOptions.bgSrc = ''
      this.fileBgList = fileList
    },
    handleCardPreview(file) {
      this.dialogImgUrl = file.url
      this.dialogImgVisible = true
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }

      const isPNG = /^.png$/.test(file.name.substring(file.name.lastIndexOf('.')));
      const isJPG = /^.jpg$/.test(file.name.substring(file.name.lastIndexOf('.')));

      if (!(isPNG || isJPG)) {
        this.$message.error("上传图片只能是PNG或JPG格式!");
        return false;
      }
      return true
    },
    clearQrStyle() {
      let that = this
      this.dialogImgVisible = false
      this.fileBgList = []
      this.fileLogoList = []
      this.$nextTick(() => {
        that.qrOptions = {
          base64Url: '',
          colorLight: '#fff',
          colorDark: '#000000',
          backgroundColor: '#fff',
          logoSrc: '',
          logoScale: 0.2,//超过0.2基本上无法识别
          logoMargin: 2,
          logoCornerRadius: 0,
          bgSrc: '',
          size: 200,
          margin: 20,
          correctLevel: 3,
        }
      })
    },
  },
};
</script>

<style scoped lang="less">
.create-qrcode {
  .bottom-title {
    border-bottom: 1px solid #cccccc;
    padding-bottom: 20px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }

  .bottom-text {
    color: black;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 2px;
  }

  .create-box {
    display: flex;
    justify-content: space-between;
  }

  .code-qr-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #6c6c6c;
    padding: 10px;
    margin-bottom: 30px;
  }

  .create-lr-box {
    width: calc(50% - 8px);
    background-color: #f9f9f9;
    box-shadow: rgba(60, 64, 67, 0.3) 0 1px 2px 0, rgba(60, 64, 67, 0.15) 0 1px 3px 1px;
    color: #6c6a6f;
  }

  .info-box {
    padding: 10px 20px;
  }

  .info-title {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .info-icon {
    color: #009999;
    margin-right: 3px;
    font-size: 22px;
    font-weight: bold;
  }

  .info-item-box {
    background-color: #f9f9f9;
    box-shadow: rgba(0, 0, 0, 0.08) 0 6px 24px 0, rgba(0, 0, 0, 0.1) 0 0 0 1px;
    padding: 20px;
  }

  .info-color-item {
    display: flex;
    align-items: center;
  }

  .info-logo-item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 35px;
    position: relative;

    .item-label {
      position: absolute;
      left: 0;
      top: 32px;
      font-size: 12px;
    }
  }

  .info-color-label {
    width: 150px;
    text-align: right;
    margin-right: 30px;
    height: 50px;
    line-height: 50px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  .submit-btn {
    text-align: center;
    letter-spacing: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceability/CreateQrcode.vue